import { API_BASE_URL, getHeaders, handleResponse } from './apiConfig';

export const fetchPaymentsList = async (academicYearId, paymentMonth, search = '') => {
  const query = new URLSearchParams();
  if (academicYearId) query.append('academic_year_id', academicYearId);
  if (paymentMonth) query.append('payment_month', paymentMonth);
  if (search) query.append('search', search);

  const response = await fetch(`${API_BASE_URL}/payments/list?${query.toString()}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const savePaymentAdjustment = async (payload) => {
  const response = await fetch(`${API_BASE_URL}/payments/save-adjustment`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};

export const processSalaryPayment = async (payload) => {
  const response = await fetch(`${API_BASE_URL}/payments/process-pay`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};
